import React from "react";
import { SUPORTE_WHATSAPP_URL } from "../config";

export default function WhatsAppFloat({
  href = SUPORTE_WHATSAPP_URL,
  label = "Falar no WhatsApp",
}) {
  return (
    <>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float whatsapp-float--pulse"
        aria-label={label}
        title={label}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(href, "_blank", "noopener,noreferrer");
        }}
      >
        <svg
          width="26"
          height="26"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M19.11 17.24c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.34-.8-.71-1.34-1.6-1.5-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.01-.22-.53-.44-.46-.61-.46h-.52c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.98 2.64 1.12 2.82.14.18 1.93 2.95 4.67 4.13.65.28 1.15.45 1.55.58.65.21 1.24.18 1.7.11.52-.08 1.6-.65 1.82-1.29.23-.64.23-1.18.16-1.29-.07-.11-.25-.18-.52-.32z"
          />
          <path
            fill="currentColor"
            d="M16 3C9.38 3 4 8.38 4 15c0 2.12.56 4.19 1.63 6.01L4 29l8.17-1.58A11.94 11.94 0 0 0 16 27c6.62 0 12-5.38 12-12S22.62 3 16 3zm0 21.5c-1.88 0-3.72-.51-5.32-1.48l-.38-.23-4.85.94.93-4.72-.25-.39A9.43 9.43 0 0 1 6.5 15C6.5 9.76 10.76 5.5 16 5.5S25.5 9.76 25.5 15 21.24 24.5 16 24.5z"
          />
        </svg>
      </a>

      {/* CSS inline (não depende do layout.css) */}
      <style>{`
        .whatsapp-float {
          position: fixed;
          right: 18px;
          bottom: 18px;
          width: 52px;
          height: 52px;
          border-radius: 16px;
          display: grid;
          place-items: center;
          z-index: 9999;
          cursor: pointer;

          color: #001b14;
          background: linear-gradient(135deg, rgba(0,210,255,0.95), rgba(0,255,170,0.92));
          box-shadow:
            0 18px 50px rgba(0, 255, 170, 0.18),
            0 12px 30px rgba(0, 210, 255, 0.12);

          border: 1px solid rgba(255,255,255,0.22);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          transition: transform .15s ease, filter .15s ease;
        }

        .whatsapp-float:hover {
          transform: translateY(-2px);
          filter: brightness(1.05);
        }

        /* Glow + pulse */
        .whatsapp-float--pulse::before {
          content: "";
          position: absolute;
          inset: -10px;
          border-radius: 22px;
          background: radial-gradient(circle, rgba(0,255,170,0.30), rgba(0,210,255,0.00) 60%);
          filter: blur(2px);
          opacity: 0.9;
          animation: wppGlow 2.2s ease-in-out infinite;
          z-index: -1;
        }

        .whatsapp-float--pulse::after {
          content: "";
          position: absolute;
          inset: -6px;
          border-radius: 20px;
          border: 1px solid rgba(0,255,170,0.38);
          animation: wppRing 1.6s ease-out infinite;
          z-index: -1;
        }

        @keyframes wppGlow {
          0%, 100% { transform: scale(0.98); opacity: 0.75; }
          50% { transform: scale(1.06); opacity: 1; }
        }

        @keyframes wppRing {
          0% { transform: scale(0.85); opacity: 0.0; }
          25% { opacity: 0.75; }
          100% { transform: scale(1.25); opacity: 0; }
        }

        /* Mobile: sobe um pouco */
        @media (max-width: 480px) {
          .whatsapp-float { right: 14px; bottom: 14px; }
        }
      `}</style>
    </>
  );
}
